import { Injectable } from '@angular/core';
import { IAdapter } from 'src/app/lego-utils';
import { Material } from 'src/app/models/domain/material';
import { YPLMMATSRVMaterialSearch } from 'src/generated-clients/material';

@Injectable({
  providedIn: 'root',
})
export class MaterialSearchAdapter implements IAdapter<Material, YPLMMATSRVMaterialSearch> {
  public get $select() {
    const propertyNames: Array<keyof YPLMMATSRVMaterialSearch> = [
      'MaterialDescrUpper',
      'MaterialNumber',
      'MaterialType',
      'CrossPlantStatus',
      'MaterialGroup',
      'DevelopmentOwnership',
    ];

    return [...propertyNames];
  }

  public adaptToDTO(_item: Partial<Material>): Partial<YPLMMATSRVMaterialSearch> {
    throw new Error('Method not implemented.');
  }

  public adaptToDomain(item: YPLMMATSRVMaterialSearch): Material {
    return new Material(
      item.MaterialNumber ?? '',
      item.MaterialType ?? '',
      item.MaterialDescrUpper ?? '',
      item.MaterialGroup ?? '',
      item.CrossPlantStatus ?? '',
      item.DevelopmentOwnership ?? ''
    );
  }
}
